export default {
  SET_FLAG(state, value) {
    state.urlFlag = value;
  },
  SET_PROJECT_NAME(state, value) {
    state.projectName = value;
  },
  SET_CURRENT_PAGE(state, value) {
    state.currentPage = value;
  },
  UNSET_VALIDATE_PROJECT_NAME(state, value) {
    state.validateProjectName = value;
  },
  UNSET_VALIDATE_PLATFORM(state, value) {
    state.validatePlatform = value;
  },
  SET_ADMIN_LINK(state, value) {
    state.adminLink = value;
  },
  SET_WEBSITE_LINK(state, value) {
    state.websiteLink = value;
  },
  SET_PLANS(state, value) {
    state.plans = value;
  },
  SET_RESELLER_OFFER(state, value) {
    state.offerActivated = value;
  },
  SET_PLAN(state, value) {
    state.selectedPlan = value;
  },
  SET_PLATFORMS(state, value) {
    state.platforms.push(value);
  },
  EMPTY_PLATFORMS(state) {
    state.platforms = [];
  },
  DELETE_PLATFORMS(state, value) {
    const index = state.platforms.findIndex((p) => p.id === value.id);
    state.platforms.splice(index, 1);
  },

  EMPTY_SUITES(state) {
    state.suites = [];
  },
  SET_SUITES(state, value) {
    value.selectStatus = true;
    state.suites.push(value);
  },
  REPLACE_SUITES(state, value) {
    state.suites.splice(0, 1);
    state.suites.push(value);
  },
  DELETE_SUITES(state, value) {
    const index = state.suites.findIndex((p) => p._id === value._id);
    state.suites.splice(index, 1);
  },
  SET_SUITE_DATA(state, value) {
    state.selectedSuiteData = value;
  },
  REPLACE_Suites_Question(state, value) {
    value.selectStatus = true;
    state.selectedSuitesQuestion[0] = value;
  },
  SET_ADDITIONAL_FEATURE(state, value) {
    state.additionalFeature = value;
  },
  VERIFY_ADDITIONAL_FEATURE(state, value) {
    state.verifyFeature = value;
  },
  VERIFIED_ADDITIONAL_FEATURE(state, value) {
    state.verifiedFeature = value;
  },
  SET_RESELLER_LEAD(state, payload) {
    state.resellerLead = payload;
  },
  SET_RECOMMEDATIONS(state, value) {
    state.recommendations = value;
  },

  // Register pages
  ENTERED_NAME(state, value) {
    state.enteredName = value;
  },
  ENTERED_NUMBER(state, value) {
    state.enteredNumber = value;
  },
  ENTERED_EMAIL(state, value) {
    state.enteredEmail = value;
  },
  SET_TOKEN(state, value) {
    state.userToken = value;
  },
  SET_USER_DETAILS(state, value) {
    state.userDetails = value;
  },
  SET_IS_CHECKED_OUT(state, value) {
    state.isCheckedOut = value;
  },
  SET_DEFAULT_PAGES(state, value) {
    state.isCheckedOut = value;
  },
  SET_PERCENTAGE(state, value) {
    state.completePercentage = value;
  },
  SET_IP_LOCATION(state, value) {
    state.ipLocation = value;
  },
};
